const billingActionTypes = {
  GET_BILLING_INFO: 'GET_BILLING_INFO',
  SET_BILLING_INFO: 'SET_BILLING_INFO',
  SET_STRIPE_PRODUCTS: 'SET_STRIPE_PRODUCTS',
  SET_STRIPE_PRODUCTS_PAYMENT_FREQUENCY:
    'SET_STRIPE_PRODUCTS_PAYMENT_FREQUENCY',
};
export default billingActionTypes;
